package org.multiplatform.kotfolio.pages.kids

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("pronounce")
@Composable
fun KidsPronounce() {
    BlogLayout(
        PageProperties(
            "Pronounce",
            "" ),
        BlogProperties("Kids", "Pronounce")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "pneumonoultramicroscopicsilicovolcanoconiosis - pneumono - ultra - microscopicsilico - volcanoconiosis - ન્યુમોનો - અલ્ટ્રા માઇક્રોસ્કોપિકસિલિકો-વોલ્કેનોકોનિઓસિસ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hippopotomonstrosesquippedaliophobia - Hippo - poto - monst - roses - quippe - dalio - phobia - હિપ્પો-પોટો-મોન્સ્ટ-ગુલાબ-ક્વિપ્પે-ડેલિયો-ફોબિયા",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sesquipedalophobia - ses - quipedalo - phobia - સેસ-ક્વિપેડેલો-ફોબિયા",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "WEDNESDAY - ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "ASTHMA - ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Receipt - ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}